const orderList = {
  order1: 1,
  order2: 2,
  order3: 3,
  order4: 4,
  order5: 5
}
const listColors = {
  [orderList.order5]: '#d84f58',
  [orderList.order4]: '#FF9F83',
  [orderList.order3]: '#C0D860',
  [orderList.order2]: '#60b3dd',
  [orderList.order1]: '#457CCE'
}
const QuestionResultMain = (data, xCategories) => ({
  credits: {
    enabled: false
  },
  chart: {
    type: "bar",
    height: 700,
    events: {
      load() {
        StaggerDataLabels(this.series);
      },
      redraw() {
        const series = this.series;
        setTimeout(() => StaggerDataLabels(series), 100);
      }
    }
  },
  colors: data.map(item => listColors[item.order]),
  title: {
    text: null
  },
  xAxis: {
    categories: xCategories,
    labels: {
      useHTML: true,
      step: 1,
      style: {
        width: 250,
        fontSize: "9px",
        textAlign: "center"
      }
    },
    min: 0,
    max: xCategories.length > 45 ? 45 : xCategories.length - 1
  },
  yAxis: {
    min: 0,
    max: 100,
    title: {
      text: false
    },
    tickInterval: 10
  },
  legend: {
    reversed: true
  },
  plotOptions: {
    series: {
      stacking: "normal",
      borderWidth: 0.5,
      borderColor: "#cdcaca",
      dataLabels: {
        enabled: true,
        crop: false,
        overflow: "none",
        allowOverlap: true,
        color: "#000000",
        padding: 0,
        style: {
          fontSize: "14px",
          textOutline: "0.7px #ffffff"
        },
        format: "{y}%",
        filter: {
          property: "percentage",
          operator: ">",
          value: 0
        }
      }
    }
  },
  tooltip: {
    valueSuffix: "%",
    backgroundColor: "#ffffff",
    outside: true
  },
  series: data
});

// staggers overlapping datalabels
const StaggerDataLabels = function (series) {
  const sc = series.length;
  if (sc < 1) return;

  for (let s = 1; s < sc; s++) {
    const s1 = series[s - 1].points;
    const s2 = series[s].points;
    const l = s1.length;
    let diff;
    let h;

    for (let i = 0; i < l; i++) {
      if (s1[i].dataLabel && s2[i].dataLabel) {
        diff = s1[i].dataLabel.y - s2[i].dataLabel.y;
        // height adjustment
        h = s1[i].dataLabel.height - 10;

        if (isLabelOnLabel(s1[i].dataLabel, s2[i].dataLabel)) {
          if (diff < 0) {
            s1[i].dataLabel.translate(
              s1[i].dataLabel.translateX,
              s1[i].dataLabel.translateY - (h + diff)
            );
          } else {
            s2[i].dataLabel.translate(
              s2[i].dataLabel.translateX,
              s2[i].dataLabel.translateY - (h - diff)
            );
          }
        }
      }
    }
  }
};

// compares two datalabels and returns true if they overlap
const isLabelOnLabel = (a, b) => {
  const al = a.x - a.width / 2;
  const ar = a.x + a.width / 2;
  const bl = b.x - b.width / 2;
  const br = b.x + b.width / 2;

  const at = a.y;
  const ab = a.y + a.height;
  const bt = b.y;
  const bb = b.y + b.height;

  if (bl > ar || br < al) {
    return false;
  } // overlap not possible
  if (bt > ab || bb < at) {
    return false;
  } // overlap not possible
  if (bl > al && bl < ar) {
    return true;
  }
  if (br > al && br < ar) {
    return true;
  }

  if (bt > at && bt < ab) {
    return true;
  }
  if (bb > at && bb < ab) {
    return true;
  }

  return false;
};

export default QuestionResultMain;



// WEBPACK FOOTER //
// ./src/models/TotalResultByAttributes.js